import { useEffect } from "react";

import styles from "../../styles/CatBtn.module.css";
import Link from "next/link";
import Image from "next/image";

export default function TagBtn({ categories = [] }) {

function myCatLoop() {
  return categories
    .filter(item => item.category_type === "Tag" || item.Type === "Tag")
    .map((item, i) => (
      <CatGrid
        key={i}
        value={i}
        urlname={item.path[0]}
        thumb={item.thumb}
        name={item.key_name || item.Tag || item.name}
      />
    ));
}


  return (
    // <div className={styles.cat_grid_container}>{myCatLoop()}</div>
    <div className={styles.TagList}> {myCatLoop()}</div>
   
  );
}

export function CatGrid(props) {

  const myImageLoader = ({}) => {
    return `${props.thumb}?w=${10}&q=${10}`;
  };

  return (
  //   <Link href={props.urlname} prefetch={false}>
  //   <a className={`${styles.thumb_1x2} ${styles.cat_thumb}`}>
  //     <div
  //       className="thumb-container"
  //     >
  //       <div className={styles.cat_con}>
  //         <div className={styles.cat_part1}>
  //             <Image
  //                 loader={myImageLoader}
  //                 src={props.thumb}
  //                 alt={props.name}
  //                 width = {112}
  //                 height = {130}
  //               />
  //         </div>
  //         <div className={styles.cat_part2}>{props.name}</div>
  //       </div>
  //     </div>
  //   </a>
  //  </Link>
  
<Link href={props.urlname} prefetch={false}>
<a>
<span className={styles.Tags}>
{props.name}
        </span>
</a>
</Link>
  );
}
